import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import br from './pt-BR.json';

const resources = {
  en: {
    translation: en,
  },
  "pt-BR": {
    translation: br,
  },
};

const getLanguage = () => {
  let selected = window.localStorage.getItem('language');

  if (!selected) {
    selected = navigator.language;
  }

  return selected;
}

i18n.use(initReactI18next).init({
  resources,
  lng: getLanguage(),
  fallbackLng: 'en',
  compatibilityJSON: 'v3',
  interpolation: {
    escapeValue: false,
  },
});
